import { render, staticRenderFns } from "./toReceive.vue?vue&type=template&id=0f91b8e4&"
import script from "./toReceive.vue?vue&type=script&lang=js&"
export * from "./toReceive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports